// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeGridContent_wrapper__Fdwnc","tooltip":"TimeGridContent_tooltip__GoxJC"};